import { Box } from "@jewlr/storybook/core"
import React from "react"

import useCollection from "areas/collection/hoc/use-collection"
import LandingSlider from "areas/landing/elements/landing-slider"
import { SectionDescription, SectionTitle } from "jewlr/pages/components"

const image_sizes = [200, 240, 280, 320, 375, 414, 500, 540, 600]

const carouselDataMapping = (data) => {
  return data.map((item) => {
    const srcSet = image_sizes
      .map(
        (dim) =>
          `${sl.config.full_main_render_url}${item.style_code}?dim=${dim} ${dim}w`
      )
      .join(", ")

    return {
      ...item,
      cta: {
        text: "Shop Now",
      },
      image: {
        alt: item.name,
        ratio: "1 / 1",
        sizes: "(max-width: 767px) 70vw, 232px",
        src: `${sl.config.full_main_render_url}${item.style_code}?dim=500`,
        srcSet,
      },
      style: {
        pl: "16px",
        width: { _: "70vw", tablet: "100%" },
      },
      title: {
        text: item.name,
      },
      type: "image",
      url: item.link,
    }
  })
}

const Slider = () => {
  const { data: { carousel } = {} } = useCollection()

  if (!carousel) return null

  const carouselData = carouselDataMapping(carousel.products)

  return (
    <Box textAlign="center">
      <SectionTitle>Want To See More?</SectionTitle>
      <SectionDescription>
        Continue shopping our other top selling collections.
      </SectionDescription>
      <LandingSlider
        element={{
          arrow_style: {
            top: "31%",
          },
          item_width: {
            _: "70vw",
            tablet: 4,
          },
          items: carouselData,
          slider_settings: {
            frameAriaLabel: "Top Selling Collections",
          },
          slider_type: "native",
          style: {
            bg: "#FFFFFF",
            mb: "100px",
            mx: { tablet: "-16px" },
            pr: {
              tablet: "16px",
            },
          },
        }}
        lazyload
      />
    </Box>
  )
}

export default Slider
